import {transferSvg as Icon__small__transferSvg} from '../Icon__small/Icon__small--transfer.js';

export var transfer = {
  name: 'transfer',
  category: 'icon',
  colorable: true,
  svg: Icon__small__transferSvg,
};
